export default __webpack_public_path__ + "static/media/icon-route-distance.d827238b.svg";